import { isEmpty, isString } from 'lodash';
import validator from 'validator';
export var validateIsEmail = function validateIsEmail(str) {
  if (!isString(str) || isEmpty(str.trim())) {
    return false;
  }

  return validator.isEmail(str);
};